<template>
  <v-carousel @change="change" color="white" :show-arrows="activeReminderIds.length > 1" :hide-delimiters="true" height="500px">
    <v-carousel-item
      v-for="(id) in activeReminderIds"
      :key="id"
    >
      <contact-update
        ref="actionContainer"
        v-if="selectedReminder.type === `contact_update`"
        :selected-reminder="selectedReminder"
        v-on:dismiss="dismiss(selectedReminder.id, true)"
      ></contact-update>
      <v-card color="white" light v-if="selectedReminder.type === `general`" height="500px">
        <v-card-title class="pl-15 pr-15 headline mb-0">{{ selectedReminder.subject }}</v-card-title>
        <v-card-text class="pl-15 pr-15" style="max-height: 380px; overflow-y: auto;">
          <v-skeleton-loader v-if="!selectedReminder"
                             type="list-item-avatar, list-item-three-line, card-heading, image, actions"
          ></v-skeleton-loader>
          <div v-else v-html="selectedReminder.body"></div>
        </v-card-text>
        <v-card-actions class="pl-15 pr-15" light>
          <v-btn
            absolute
            bottom
            right
            @click="dismiss(selectedReminder.id)"
            :loading="loading"
            color="primary"
          >Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import {mapGetters} from "vuex";
import ContactUpdate from "@/components/reminder/ContactUpdate";

export default {
  components: {ContactUpdate},
  methods: {
    async dismiss(id, actionCompleted) {
      const actionCompletedAt = (actionCompleted) ? new Date() : undefined
      await this.$store.dispatch(`markReminderAsRead`, {id, read: 1, actionCompletedAt})
      this.loading = false
      if (this.activeReminderIds.length === 0) this.$emit('close')
    },
    async change($event) {
      const id = this.activeReminderIds[$event];
      if (id) {
        if (this.loadedReminders[id]) this.selectedReminder = this.loadedReminders[id]
        else {
          this.selectedReminder = this.loadedReminders[id] = await this.$store.dispatch(`fetchReminder`, {
            id
          })
        }
      }
    }
  },
  props: ['activeReminderIds'],
  data() {
    return {
      loading: false,
      selectedReminder: {},
      loadedReminders: {}
    }
  },
  computed: {
    ...mapGetters(['getConfig']),
  }
}
</script>